export const ID_PROGRAM_TYPE = {
    JLJS: 1,
    VISIBILITY_PLUS: 3,
    APM: 10,
    XPRESSCONNECTION: 10,
    APM2: 13,
}

export const PROGRAM_TYPE = {
    APM: "apm",
    APM2: "apm2",
    SCHEDULED_CAMPAIGNS: "Scheduled Campaigns",
    VISIBILITY_PLUS: "Visibility Plus",
}

